/* global PUSH_FIREBASE_API_KEY */
/* global PUSH_FIREBASE_AUTH_DOMAIN */
/* global PUSH_FIREBASE_PROJECT_ID */
/* global PUSH_FIREBASE_STORAGE_BUCKET */
/* global PUSH_FIREBASE_MESSAGING_SENDER_ID */
/* global PUSH_FIREBASE_APP_ID */
/* global PUSH_FIREBASE_MEASUREMENT_ID */

import { FirebaseApp, initializeApp } from 'firebase/app';
import { Messaging, getMessaging } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: PUSH_FIREBASE_API_KEY,
  authDomain: PUSH_FIREBASE_AUTH_DOMAIN,
  projectId: PUSH_FIREBASE_PROJECT_ID,
  storageBucket: PUSH_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: PUSH_FIREBASE_MESSAGING_SENDER_ID,
  appId: PUSH_FIREBASE_APP_ID,
  measurementId: PUSH_FIREBASE_MEASUREMENT_ID,
};

// Check if we're in a browser environment that supports Firebase Messaging
const isBrowserEnvironment =
  typeof window !== 'undefined' && typeof navigator !== 'undefined' && 'serviceWorker' in navigator;

let app: FirebaseApp | null = null;
let messagingInstance: Messaging | null = null;

// Lazy initialization function
const initializeMessaging = (): Messaging | null => {
  if (!isBrowserEnvironment) {
    return null;
  }

  if (!messagingInstance) {
    try {
      // Initialize a separate Firebase app instance for Push Notifications
      // We give it a name 'PUSH_APP' to avoid conflict with the default app
      app = initializeApp(firebaseConfig, 'PUSH_APP');
      messagingInstance = getMessaging(app);
    } catch (_error) {
      // Silently fail - messaging will remain null
      return null;
    }
  }

  return messagingInstance;
};

// Only initialize in browser environment
// This prevents initialization during test runs
let messaging: Messaging | null = null;
if (isBrowserEnvironment) {
  messaging = initializeMessaging();
}

// Export messaging instance
export { messaging };

// Export app getter
export const getApp = (): FirebaseApp | null => app;

export default app;
